import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import checkNote from '../../../../../assets/images/checkNote.svg';
import { HEADERMENU_PATH } from '../../../../../routes/RoutesURL';
import { RootState } from '../../../../../store/rootReducer';
import HSButton from '../../../../common/Button';
import { UserStatus } from '../../../../login/utils/Status';
import OnboardingCard from '../common/Card';

const KYCThankYou: React.FC = () => {
    const navigate = useNavigate();

    const userStatus = useSelector((state: RootState) => state.user.user?.status);

    const onClickStartInvesting = () => {
        if (userStatus && userStatus === UserStatus.pendingActivation) {
            navigate(HEADERMENU_PATH.accountActivationWithOtp);
        } else {
            navigate(`/`);
        }
    };

    return (
        <div className="w-full m-auto mt-8">
            <OnboardingCard>
                <div className="flex justify-center items-center w-full flex-col">
                    <div className="w-14 h-14 rounded-full border border-green-400 flex justify-center items-center">
                        <img src={checkNote} alt="checknote" className="w-5" />
                    </div>
                    <p className="my-4 Canela-Regular text-xl text-color-404040">Thank you</p>
                    <p className="text-color-404040 text-center text-sm w-full md:w-11/12">
                        Congratulations, your KYC details are submitted. A Helicap representative will review your
                        details and keep you updated. Meanwhile, feel free to explore our platform. Welcome aboard!
                    </p>
                    <div className="flex justify-center items-center mt-8 mb-5 flex-col">
                        <HSButton title="START INVESTING" type="primary" onClick={onClickStartInvesting} />
                    </div>
                </div>
            </OnboardingCard>
        </div>
    );
};

export default KYCThankYou;
